import { createBuyBonusComponent } from '@modules/src/buyBonus/createBuyBonusComponent'
import { IComponent } from '@modules/src/interfaces/IComponents'
import { ContainersNames } from '@/containers/ContainersNames'

// Quick customization examples:
// 1) assets + resolveAssetName: map a different naming convention without touching core logic
// 2) itemPatches: override position/scale/src of existing elements
// 3) appendItems: add new custom elements just like a regular component
// Tip: in your real implementation, prefer enums instead of raw numbers:
// import { AssetType } from '@modules/src/enums/AssetType'
// import { Orientation } from '@modules/src/enums/Orientation'
//
// Note: examples are intentionally commented out. Uncomment only the blocks you need.
export const BUY_BONUS_COMPONENT: IComponent = createBuyBonusComponent({
    containerName: ContainersNames.BUY_BONUS_CONTAINER,

    // EXAMPLE 1: Custom asset naming convention
    // assets: {
    //     // Explicit single-asset override
    //     assets: {
    //         popupBackground: 'bb_popup_bg.png',
    //         confirmLabel: 'bb_btn_label_buy.png',
    //     },
    //     // Global resolver: transforms every fallback name to your format
    //     // (example: "buybonuspopupcontainer.png" -> "ccg_buybonuspopupcontainer.png")
    //     resolveAssetName: (_assetKey, fallbackFileName) => `ccg_${fallbackFileName}`,
    // },

    // EXAMPLE 2: Patch existing elements
    // itemPatches: [
    //     {
    //         targetName: 'Buy Bonus Popup Content',
    //         mode: 'merge',
    //         patch: {
    //             // Replace popup container portrait/landscape position
    //             position: [
    //                 { orientation: Orientation.LANDSCAPE, x: 500, y: 40 },
    //                 { orientation: Orientation.PORTRAIT, x: -20, y: 330 },
    //             ],
    //         },
    //     },
    //     {
    //         targetName: 'Buy Bonus Button',
    //         mode: 'merge',
    //         patch: {
    //             src: 'bb_buy_btn_normal.png',
    //             scale: [
    //                 { orientation: Orientation.LANDSCAPE, x: 0.9, y: 0.9 },
    //                 { orientation: Orientation.PORTRAIT, x: 0.8, y: 0.8 },
    //             ],
    //         },
    //     },
    // ],

    // EXAMPLE 3: Lifecycle hooks — run side effects alongside default logic
    // hooks: {
    //     // Called when the popup opens — e.g. play an animation or log analytics
    //     onOpen: () => {
    //         GameSignals.someAnimationSignal.emit()
    //         console.log('[BuyBonus] popup opened')
    //     },
    //     // Called when the popup closes
    //     onClose: () => {
    //         console.log('[BuyBonus] popup closed')
    //     },
    //     // Called every time the bet display refreshes — receives current coin bet
    //     onBetChange: (amount) => {
    //         console.log('[BuyBonus] bet changed:', amount)
    //     },
    //     // Called after the player clicks confirm/buy
    //     onConfirm: () => {
    //         console.log('[BuyBonus] player confirmed buy')
    //     },
    //     // Extra signals to emit automatically on open/close/confirm
    //     additionalSignalsOnOpen: ['trackBuyBonusImpression'],
    //     additionalSignalsOnConfirm: ['trackBuyBonusPurchase'],
    // },

    // EXAMPLE 4: Append custom element(s) into popup
    // appendItems: [
    //     {
    //         parentName: 'Buy Bonus Popup Content',
    //         items: [
    //             {
    //                 name: 'Buy Bonus Promo Badge',
    //                 type: AssetType.SPRITE,
    //                 src: 'bb_promo_badge.png',
    //                 anchor: 0.5,
    //                 position: [
    //                     { orientation: Orientation.LANDSCAPE, x: 40, y: 120 },
    //                     { orientation: Orientation.PORTRAIT, x: 80, y: 140 },
    //                 ],
    //                 scale: [
    //                     { orientation: Orientation.LANDSCAPE, x: 0.8, y: 0.8 },
    //                     { orientation: Orientation.PORTRAIT, x: 0.7, y: 0.7 },
    //                 ],
    //             },
    //         ],
    //     },
    // ],
})
